/* ─── OSTIVEX — Translations & Copy ─────────────────────────────────────────
   Regole:
   · Niente claim non supportati (es. "zero manutenzione", "in pochi minuti")
   · Benefici concreti e operativi, non slogan astratti
   · Tono: premium, diretto, B2B. Non corporate freddo, non startup gonfiato
   · CTA primaria unica: "Attiva demo gratuita" / "Activate free demo"
   · CTA secondaria: "Scopri i prezzi" / "View pricing"
──────────────────────────────────────────────────────────────────────────── */

export const T = {
  it: {
    /* NAV */
    nav_features: 'Funzionalità',
    nav_integrations: 'Integrazioni',
    nav_pricing: 'Prezzi',
    nav_faq: 'FAQ',
    nav_login: 'Accedi',
    nav_demo: 'Attiva Demo Gratuita',

    /* ── HERO ─────────────────────────────────────────────────────── */
    hero_eyebrow: 'Piattaforma B2B · Hospitality Luxury',
    hero_title: 'Accessi digitali,\nprenotazioni e ospiti.',
    hero_title_gold: 'Da un unico pannello.',
    hero_sub: 'Shangrilux è la piattaforma operativa per hotel boutique, ville luxury e property manager. Centralizza accessi digitali, prenotazioni, smart home e guest experience — eliminando i flussi manuali tra sistemi separati.',
    hero_cta: 'Attiva demo gratuita',
    hero_cta2: 'Scopri i prezzi',
    hero_stat1: '18',       hero_stat1_sub: 'brand smart home certificati',
    hero_stat2: '24h',      hero_stat2_sub: 'per esplorare la demo',
    hero_stat3: '3',        hero_stat3_sub: 'piani, nessun costo nascosto',
    hero_stat4: 'IT · EN',  hero_stat4_sub: 'pannello bilingue nativo',

    /* ── PROBLEMA ─────────────────────────────────────────────────── */
    problem_label: 'Il problema',
    problem_title: 'Le strutture luxury hanno standard alti.\nSpesso i loro strumenti no.',
    problem_sub: 'I tuoi ospiti si aspettano un\'esperienza fluida dall\'arrivo al checkout. Eppure la maggior parte delle strutture continua a gestire accessi, prenotazioni e comunicazioni con strumenti separati, processi manuali e dati non tracciati.',
    problem1_t: 'Chiavi fisiche e coordinamento manuale',
    problem1_d: 'Ogni cambio ospite richiede uno scambio fisico: ritardi, blocchi, rischi di sicurezza. Se una chiave si perde o viene copiata, il problema è tuo.',
    problem2_t: 'Sistemi che non parlano tra loro',
    problem2_d: 'Prenotazioni su una piattaforma, smart home su un\'altra, preventivi via email. Nessuna visione unificata, nessun log, tempo perso a riallineare dati.',
    problem3_t: 'Operatività senza tracciabilità',
    problem3_d: 'Conferme, rifiuti, aggiornamenti ai fornitori vengono gestiti caso per caso, senza storico e senza automazione. Ogni errore è difficile da ricostruire.',
    solution_label: 'La soluzione',
    solution_title: 'Un pannello admin.\nTutte le operazioni, tutte tracciate.',

    /* ── FEATURES ─────────────────────────────────────────────────── */
    feat_title: 'Funzioni concrete,',
    feat_title2: 'non un lungo elenco di opzioni.',
    feat_sub: 'Shangrilux include gli strumenti che una struttura luxury usa davvero, in un pannello admin bilingue. Niente da integrare, niente da tenere allineato.',
    f1_t: 'Chiavi Digitali',
    f1_d: 'L\'ospite riceve un link via email o WhatsApp. Apre porte, cancelli e garage dal telefono, senza installare nulla. La chiave è valida solo nelle ore di soggiorno e scade al checkout — automaticamente.',
    f2_t: 'Smart Home',
    f2_d: 'Compatibile con Nuki, Tuya, KNX, Home Assistant, Loxone, BTicino e altri 12 brand già testati. Controllo scene e dispositivi dal pannello admin o dalla Guest App.',
    f3_t: 'Portale Prenotazioni',
    f3_d: 'Calendario interattivo, servizi aggiuntivi selezionabili dall\'ospite, preventivo PDF automatico, email di conferma o rifiuto personalizzate. Tutto tracciato per stato.',
    f4_t: 'Guest App',
    f4_d: 'Installabile su iPhone e Android direttamente dal browser — nessun passaggio negli store. Funziona anche senza connessione: i comandi vengono salvati localmente e sincronizzati non appena la rete è disponibile.',
    f5_t: 'Portale Fornitori',
    f5_d: 'I fornitori accedono tramite link privato, vedono i dettagli del servizio richiesto e inviano la loro offerta. Il preventivo si aggiorna automaticamente nel pannello.',
    f6_t: 'Dashboard Operativa',
    f6_d: 'Pannello urgenze, ricavi con export CSV, log accessi per dispositivo e per operatore. Gestione utenti con tre livelli di permesso: superadmin, admin, viewer.',
    f7_t: 'Testi Personalizzabili',
    f7_d: 'Ogni testo della piattaforma — italiano e inglese — è modificabile dal pannello admin senza competenze tecniche. Messaggi di benvenuto, conferme, email: tutto è tuo.',
    f8_t: 'Automazioni',
    f8_d: 'Le prenotazioni in attesa scadono entro la finestra configurata. Le sessioni vengono pulite, le notifiche inviate, i token aggiornati. Nessuna routine da eseguire a mano.',

    /* ── PER CHI È ────────────────────────────────────────────────── */
    for_who_label: 'Per chi è',
    for_who_title: 'Non per tutti. Per chi\nvuole fare le cose bene.',
    for_who_sub: 'Shangrilux è utile quando gestisci una struttura con standard operativi elevati, più proprietà o ospiti che si aspettano un\'esperienza senza attriti.',
    for_who_1_tag: 'Boutique Hotel',
    for_who_1_title: '4–30 camere',
    for_who_1_desc: 'Check-in senza reception, chiave digitale per ogni camera, log accessi in tempo reale. Lo staff si occupa dell\'accoglienza, non della logistica delle chiavi.',
    for_who_2_tag: 'Villa & Affitto Luxury',
    for_who_2_title: 'Da 1 a 10 proprietà',
    for_who_2_desc: 'Portale prenotazioni con preventivo PDF, smart home collegata, chiave digitale per ogni soggiorno. Puoi delegare le operazioni allo staff mantenendo piena visibilità.',
    for_who_3_tag: 'Property Manager',
    for_who_3_title: 'Portfolio multi-struttura',
    for_who_3_desc: 'Un unico accesso admin per più proprietà indipendenti. Ogni struttura ha il suo database, i suoi ospiti e le sue configurazioni. Report e CSV consolidati.',
    for_who_4_tag: 'Resort & Hotel B2B',
    for_who_4_title: 'Automazione avanzata',
    for_who_4_desc: 'Supporto KNX, multi-zona e controllo scene. White-label completo: nessun riferimento a Shangrilux nella UI ospite. API pubblica e webhook per l\'integrazione con il tuo PMS.',

    /* ── INTEGRAZIONI ─────────────────────────────────────────────── */
    integrations_label: 'Smart Home',
    integrations_title: 'Compatibile con i brand\nche hai già.',
    integrations_sub: '18 brand integrati e testati in produzione. Se usi già Nuki, Tuya, KNX o Home Assistant, Shangrilux si collega senza sostituire l\'hardware. Nuove integrazioni aggiunte su richiesta.',
    integrations_cta: 'Esplora il Marketplace',

    /* ── RUOLI TEAM ───────────────────────────────────────────────── */
    team_label: 'Il tuo team',
    team_title: 'Ogni persona vede\nsolo quello che serve.',
    team_sub: 'Shangrilux usa un sistema di ruoli per garantire che ogni membro del team — staff, fornitori, ospiti — abbia accesso alle funzioni giuste, senza eccessi e senza doversi formare su tutto.',
    team_1_role: 'Proprietario',
    team_1_title: 'Controllo completo.',
    team_1_desc: 'Dashboard con occupazione, ricavi e log operativi. Export CSV, configurazione strutture e gestione piani. Può delegare senza perdere visibilità su nulla.',
    team_2_role: 'Staff',
    team_2_title: 'Solo le operazioni di competenza.',
    team_2_desc: 'Conferma o rifiuta prenotazioni, invia la chiave digitale all\'ospite, gestisce i servizi. Accede solo ai dati della sua struttura, senza aree riservate.',
    team_3_role: 'Fornitore',
    team_3_title: 'Portale dedicato, nessun account.',
    team_3_desc: 'Riceve un link privato via email. Vede le specifiche del servizio richiesto e invia l\'offerta. Nessuna registrazione, nessun accesso al pannello admin.',
    team_4_role: 'Ospite',
    team_4_title: 'Accesso autonomo, zero attriti.',
    team_4_desc: 'Riceve un link via email o WhatsApp. Apre la porta, consulta le informazioni della struttura, controlla i dispositivi smart — dal telefono, senza scaricare nulla.',

    /* ── PERCHÉ OSTIVEX ───────────────────────────────────────────── */
    why_label: 'Differenze',
    why_title: 'Cosa include Shangrilux\nche i PMS generici non hanno.',
    compare_feature: 'Funzione',
    compare_other: 'PMS / Software generici',
    compare_ostivex: 'Shangrilux',
    compare_rows_it: [
      ['Chiave digitale senza app installata',          false, true],
      ['Smart home nativa (18 brand)',                  false, true],
      ['Portale fornitori con preventivo PDF',          false, true],
      ['Guest App installabile via browser',            false, true],
      ['White-label senza riferimenti al fornitore',   false, true],
      ['Pannello bilingue italiano / inglese',          false, true],
      ['Multi-struttura con database isolati',          false, true],
      ['API pubblica + Webhook firmato HMAC-SHA256',    false, true],
    ],

    /* ── COME FUNZIONA ────────────────────────────────────────────── */
    how_label: 'Setup',
    how_title: 'Attivo in tre fasi.',
    how1_t: '01 · Configurazione',
    how1_d: 'Il wizard guidato ti porta dalla creazione dell\'account admin alla configurazione della struttura. Richiede circa 15–30 minuti. Puoi farlo in autonomia o con il supporto del nostro team.',
    how2_t: '02 · Personalizzazione',
    how2_d: 'Aggiungi le tariffe stagionali, i servizi disponibili e le regole di prenotazione. Se hai dispositivi smart home, li colleghi in questa fase tramite le integrazioni già attive.',
    how3_t: '03 · Operativo',
    how3_d: 'Il portale prenotazioni, le chiavi digitali e la Guest App sono pronti. Le automazioni partono in automatico: scadenze, notifiche e pulizia sessioni non richiedono intervento manuale.',

    /* ── TESTIMONIAL ──────────────────────────────────────────────── */
    testimonials_label: 'Chi lo usa',
    testimonials_title: 'Tre casi reali.',
    testimonials: [
      {
        name: 'Marco Visentin',
        role: 'Proprietario · Villa Monterosa',
        location: 'Lago di Como, CO',
        text: 'Prima del check-in dovevo coordinare fisicamente la consegna delle chiavi — spesso con ritardi o problemi. Adesso l\'ospite riceve un link, apre la porta dal telefono e non mi chiama più. Il check-in è completamente autonomo.',
        stars: 5,
        metric: 'Accesso completamente autonomo',
      },
      {
        name: 'Giulia Raffaelli',
        role: 'Operations Manager · Palazzo Cà Nova',
        location: 'Venezia, VE',
        text: 'Gestisco 12 appartamenti. Prima usavamo tre strumenti diversi per prenotazioni, preventivi e comunicazioni. Ora è tutto nello stesso pannello. Il tempo dedicato all\'amministrazione si è ridotto in modo significativo — posso quantificarlo intorno al 50–60%.',
        stars: 5,
        metric: '12 proprietà, un pannello',
      },
      {
        name: 'Andrea Mancini',
        role: 'Direttore · Boutique Hotel Arcadia',
        location: 'Firenze, FI',
        text: 'Volevo una soluzione che non mostrasse il nome del fornitore agli ospiti. Con il piano Elite ho il white-label completo: il pannello è nostro, i testi sono nostri. L\'integrazione Nuki ha eliminato del tutto la logistica fisica delle chiavi.',
        stars: 5,
        metric: 'White-label completo, zero dipendenza visiva',
      },
    ],

    /* ── SICUREZZA ────────────────────────────────────────────────── */
    security_label: 'Sicurezza operativa',
    security_title: 'Ogni accesso è tracciato.\nOgni operazione registrata.',
    security_sub: 'Shangrilux è costruito per ambienti in cui la tracciabilità non è opzionale. Gli accessi fisici, le operazioni admin e i dati degli ospiti sono separati, firmati e auditabili.',
    security_1_t: 'Log accessi in tempo reale',
    security_1_d: 'Ogni apertura porta, ogni comando smart home, ogni azione admin viene registrata con timestamp, IP e identità dell\'operatore. Esportabile in CSV.',
    security_2_t: 'Ruoli e permessi separati',
    security_2_d: 'Tre livelli di accesso: superadmin, admin, viewer. Nessun membro del team vede dati al di fuori della sua area. Le deleghe non compromettono la visibilità del proprietario.',
    security_3_t: 'Chiavi digitali con scadenza crittografica',
    security_3_d: 'Ogni chiave è firmata con HMAC univoco e valida solo durante le ore di soggiorno configurate. Non è riutilizzabile, non è trasferibile, non si può estendere senza autorizzazione.',
    security_4_t: 'Isolamento dati per struttura',
    security_4_d: 'Ogni struttura ha il proprio database — i dati di un tenant non sono mai accessibili agli altri. Architettura multi-tenant con isolamento completo e cancellazione su richiesta.',
    security_5_t: 'Webhook con firma verificabile',
    security_5_d: 'Gli eventi inviati ai sistemi esterni includono una firma HMAC-SHA256 verificabile. Ogni consegna fallita viene ritentata automaticamente con log dello stato.',
    security_6_t: 'Audit trail operazioni',
    security_6_d: 'Ogni modifica al pannello è tracciata: chi ha confermato una prenotazione, chi ha cambiato una tariffa, chi ha revocato una chiave. Consultabile in qualsiasi momento.',

    /* ── PRICING ──────────────────────────────────────────────────── */
    pricing_label: 'Prezzi',
    pricing_title: 'Tre piani.', pricing_title2: 'Prezzi chiari, senza sorprese.',
    pricing_sub: 'Ogni piano include pannello admin completo, portale prenotazioni, Guest App e supporto. La fatturazione è annuale, un\'unica soluzione anticipata.',
    pricing_monthly_label: '/ mese', pricing_annual_label: '· fatturati annualmente',
    pricing_cta: 'Attiva demo gratuita',
    pricing_popular: 'Più scelto',
    plan1_name: 'Essenziale',
    plan1_desc: 'Una struttura, accessi digitali e prenotazioni. Il punto di partenza per chi vuole eliminare le chiavi fisiche e avere il controllo delle prenotazioni senza aggiungere complessità.',
    plan2_name: 'Professional',
    plan2_desc: 'Fino a 5 proprietà, smart home, portale fornitori e report avanzati. La scelta di property manager e hotel boutique che hanno bisogno di una piattaforma operativa completa.',
    plan3_name: 'Elite',
    plan3_desc: 'Proprietà illimitate, white-label senza riferimenti Shangrilux, API e webhook per integrarsi con PMS e sistemi gestionali. Per strutture che richiedono pieno controllo e integrazione.',

    /* ── FAQ ──────────────────────────────────────────────────────── */
    faq_label: 'FAQ',
    faq_title: 'Domande frequenti.',
    q1: 'Posso togliere il marchio Shangrilux e usare il mio brand?',
    a1: 'Sì, con il piano Elite. Il white-label riguarda l\'intera interfaccia: il pannello admin, la Guest App e le email automatiche non conterranno riferimenti a Shangrilux. Il nome, il logo e i colori possono essere personalizzati. Con il piano Professional puoi impostare il nome della struttura, ma il branding Shangrilux rimane visibile.',
    q2: 'Quanto è complessa l\'integrazione smart home?',
    a2: 'Dipende dal dispositivo. Tuya, Home Assistant e webhook generici si configurano in autonomia dal pannello admin, solitamente in meno di 30 minuti. Nuki richiede il pairing del bridge fisico, guidato da documentazione step-by-step. KNX e BACnet richiedono normalmente un installatore certificato per la configurazione del bus. In tutti i casi forniamo documentazione specifica per brand e siamo disponibili a supportare il setup.',
    q3: 'Posso gestire più proprietà dallo stesso accesso?',
    a3: 'Sì. Dal piano Professional puoi aggiungere fino a 5 strutture indipendenti, ciascuna con il proprio database, i propri ospiti e le proprie integrazioni. Con Elite le strutture sono illimitate. Ogni struttura è isolata: i dati non si mescolano e le configurazioni sono separate.',
    q4: 'Come funziona la demo gratuita?',
    a4: 'Compili il form con nome, struttura ed email. Entro pochi secondi ricevi le credenziali di accesso a un ambiente pre-configurato: una proprietà demo, tariffe stagionali, una prenotazione in stato pending, una chiave digitale attiva e la Guest App funzionante. Hai 24 ore per esplorare tutto. Nessuna carta di credito, nessuna disdetta — l\'ambiente si cancella automaticamente.',
    q5: 'Come funziona la fatturazione?',
    a5: 'I piani sono fatturati annualmente in un\'unica soluzione. Il prezzo mensile indicato è l\'equivalente mensile dell\'importo annuale. Non ci sono costi di setup, commissioni per prenotazione, soglie di traffico o addebiti variabili. Quello che vedi è quello che paghi.',
    q6: 'Cosa succede se supero il numero di proprietà incluse nel mio piano?',
    a6: 'Ricevi una notifica prima di raggiungere il limite. Puoi fare upgrade in qualsiasi momento: tutti i dati, le configurazioni e lo storico vengono mantenuti. Non c\'è blocco automatico né interruzione del servizio.',
    q7: 'Esiste un\'opzione di acquisto permanente?',
    a7: 'Sì. La licenza Lifetime dà accesso permanente alla piattaforma, compresi tutti gli aggiornamenti futuri, senza canone annuale. È disponibile su richiesta con offerta personalizzata in base al numero di strutture. Scrivici a info@shangrilux.com per ricevere una proposta.',
    q8: 'Posso installarlo su un mio server o cloud privato?',
    a8: 'Sì. Shangrilux è disponibile in modalità self-hosted su qualsiasi server Linux con Docker. Forniamo: documentazione di installazione, variabili d\'ambiente, script di avvio e supporto all\'onboarding. Puoi usare il tuo provider cloud (AWS, Hetzner, OVH, ecc.) e mantenere il pieno controllo dei dati e dell\'infrastruttura.',
    q9: 'Che tipo di supporto è incluso?',
    a9: 'Il piano Essenziale include supporto via email con risposta entro 48 ore lavorative. Professional include supporto prioritario con risposta entro 24 ore. Elite include un canale dedicato (email + video call su prenotazione), tempo di risposta garantito contrattualmente e sessioni di onboarding assistito per la configurazione iniziale.',
    q10: 'I dati degli ospiti sono al sicuro?',
    a10: 'Ogni struttura ha un database fisicamente isolato dagli altri — è un\'architettura multi-tenant con separazione completa. Le chiavi digitali usano firma crittografica HMAC-SHA256 e scadono automaticamente a fine soggiorno. Tutte le operazioni admin sono tracciate in un audit log immutabile. I dati vengono cancellati alla fine del contratto su richiesta scritta, senza costi aggiuntivi.',

    /* ── DEMO FORM ────────────────────────────────────────────────── */
    demo_label: 'Demo gratuita',
    demo_title: '24 ore per esplorare\nShangrilux senza impegno.',
    demo_sub: 'Nessuna carta di credito. Ricevi subito le credenziali per un ambiente completo con dati preconfigurati e tutte le funzioni del piano Elite attive.',
    demo_badge: 'Piano Elite · 24 ore · Cancellazione automatica',
    demo_name: 'Nome e cognome',
    demo_company: 'Nome della struttura',
    demo_email: 'Indirizzo email',
    demo_phone: 'Telefono (opzionale)',
    demo_plan: 'Piano di interesse',
    demo_submit: 'Attiva demo gratuita',
    demo_submitting: 'Creazione in corso...',
    demo_success_title: 'La tua demo è pronta.',
    demo_success_sub: 'Hai 24 ore per esplorare l\'ambiente con dati preconfigurati. Le credenziali sono anche nell\'email che ti abbiamo inviato.',
    demo_copy: 'Copia link',
    demo_copied: 'Copiato!',
    demo_open_panel: 'Apri il pannello admin',
    demo_credentials: 'Credenziali di accesso',
    demo_expires: 'Demo attiva per 24 ore · si cancella in automatico alla scadenza',
    demo_email_note: 'Credenziali inviate anche all\'email indicata.',
    demo_microcopy: 'Nessuna carta richiesta · Attivo immediatamente · Cancellazione automatica',
    demo_items: [
      'Struttura demo con tariffe stagionali configurate',
      'Servizi aggiuntivi (colazione, transfer, late checkout)',
      '1 prenotazione in stato pending con chiave digitale attiva',
      'Guest App funzionante (apribile da mobile)',
      'Piano Elite attivo: tutte le funzioni senza limitazioni',
    ],

    /* ── LOGIN ────────────────────────────────────────────────────── */
    login_title: 'Accedi al pannello',
    login_sub: 'Inserisci lo slug della struttura per aprire il pannello admin.',
    login_slug_label: 'Slug struttura',
    login_slug_placeholder: 'es. villa-aurora',
    login_go: 'Apri il pannello',
    login_no_account: 'Non hai ancora accesso?',

    /* ── FOOTER ───────────────────────────────────────────────────── */
    footer_tagline: 'Piattaforma operativa per strutture hospitality luxury.',
    footer_dev: 'Progettato e sviluppato da',
    footer_rights: 'Tutti i diritti riservati.',
    footer_privacy: 'Privacy Policy',
    footer_terms: 'Termini di servizio',
    footer_contact: 'Contatti',
  },

  /* ═══════════════════════════════════════════════════════════════════════
     ENGLISH
  ═══════════════════════════════════════════════════════════════════════ */
  en: {
    /* NAV */
    nav_features: 'Features',
    nav_integrations: 'Integrations',
    nav_pricing: 'Pricing',
    nav_faq: 'FAQ',
    nav_login: 'Login',
    nav_demo: 'Activate Free Demo',

    /* ── HERO ─────────────────────────────────────────────────────── */
    hero_eyebrow: 'B2B Platform · Luxury Hospitality',
    hero_title: 'Digital access,\nbookings and guests.',
    hero_title_gold: 'From one panel.',
    hero_sub: 'Shangrilux is the operations platform for boutique hotels, luxury villas and property managers. It centralises digital access, bookings, smart home and guest experience — removing the manual workflows between separate systems.',
    hero_cta: 'Activate free demo',
    hero_cta2: 'View pricing',
    hero_stat1: '18',       hero_stat1_sub: 'certified smart home brands',
    hero_stat2: '24h',      hero_stat2_sub: 'to explore the demo',
    hero_stat3: '3',        hero_stat3_sub: 'plans, no hidden costs',
    hero_stat4: 'IT · EN',  hero_stat4_sub: 'native bilingual panel',

    /* ── PROBLEM ──────────────────────────────────────────────────── */
    problem_label: 'The problem',
    problem_title: 'Luxury properties have high standards.\nOften their tools don\'t.',
    problem_sub: 'Your guests expect a seamless experience from arrival to checkout. Yet most properties still manage access, bookings and communications across separate tools — with manual processes and no shared data.',
    problem1_t: 'Physical keys and manual coordination',
    problem1_d: 'Every guest changeover requires a physical handover: delays, lockouts, security risks. If a key is lost or copied, it\'s your problem to solve.',
    problem2_t: 'Systems that don\'t connect',
    problem2_d: 'Bookings on one platform, smart home on another, quotes by email. No unified view, no shared log, time wasted realigning data.',
    problem3_t: 'Operations without traceability',
    problem3_d: 'Confirmations, rejections, supplier updates handled case by case, with no audit trail and no automation. Every mistake is hard to reconstruct.',
    solution_label: 'The solution',
    solution_title: 'One admin panel.\nAll operations, all tracked.',

    /* ── FEATURES ─────────────────────────────────────────────────── */
    feat_title: 'Concrete features,',
    feat_title2: 'not a long list of options.',
    feat_sub: 'Shangrilux includes the tools a luxury property actually uses, in a single bilingual admin panel. Nothing to integrate separately, nothing to keep in sync.',
    f1_t: 'Digital Keys',
    f1_d: 'Guests receive a link by email or WhatsApp. They open doors, gates and garages from their phone — no app to install. The key is valid only during their stay and expires at checkout automatically.',
    f2_t: 'Smart Home',
    f2_d: 'Compatible with Nuki, Tuya, KNX, Home Assistant, Loxone, BTicino and 12 more brands, all tested in production. Control scenes and devices from the admin panel or Guest App.',
    f3_t: 'Booking Portal',
    f3_d: 'Interactive calendar, add-on services selectable by the guest, automatic PDF quote, personalised confirmation and rejection emails. Everything tracked by status.',
    f4_t: 'Guest App',
    f4_d: 'Installable on iPhone and Android directly from the browser — no app store needed. Works offline: commands are saved locally and synced as soon as the connection is restored.',
    f5_t: 'Supplier Portal',
    f5_d: 'Suppliers access via a private link, see service details and submit their quote. The estimate updates automatically in the admin panel.',
    f6_t: 'Operations Dashboard',
    f6_d: 'Urgency panel, revenue CSV export, per-device and per-operator access logs. User management with three permission levels: superadmin, admin, viewer.',
    f7_t: 'Editable Texts',
    f7_d: 'Every platform text — Italian and English — is editable from the admin panel without technical skills. Welcome messages, confirmations, emails: everything is yours to customise.',
    f8_t: 'Automations',
    f8_d: 'Pending bookings expire within the configured window. Sessions are cleaned, notifications sent, tokens updated — no routine to run manually.',

    /* ── FOR WHO ──────────────────────────────────────────────────── */
    for_who_label: 'Who it\'s for',
    for_who_title: 'Not for everyone. For those\nwho want to do it right.',
    for_who_sub: 'Shangrilux is useful when you manage a property with high operational standards, multiple venues, or guests who expect a frictionless experience.',
    for_who_1_tag: 'Boutique Hotel',
    for_who_1_title: '4–30 rooms',
    for_who_1_desc: 'Contactless check-in, digital key per room, real-time access logs. Staff focus on hospitality, not key handovers.',
    for_who_2_tag: 'Luxury Villa & Rental',
    for_who_2_title: '1 to 10 properties',
    for_who_2_desc: 'Booking portal with PDF quote, connected smart home, digital key for each stay. Delegate operations to staff while keeping full visibility.',
    for_who_3_tag: 'Property Manager',
    for_who_3_title: 'Multi-property portfolio',
    for_who_3_desc: 'One admin login for multiple independent properties. Each has its own database, guests and config. Consolidated reports and CSV export.',
    for_who_4_tag: 'Resort & B2B Hotel',
    for_who_4_title: 'Advanced automation',
    for_who_4_desc: 'KNX support, multi-zone, scene control. Full white-label: no Shangrilux branding in the guest UI. Public API and webhooks to connect with your PMS.',

    /* ── INTEGRATIONS ─────────────────────────────────────────────── */
    integrations_label: 'Smart Home',
    integrations_title: 'Compatible with the brands\nyou already have.',
    integrations_sub: '18 brands integrated and tested in production. If you already use Nuki, Tuya, KNX or Home Assistant, Shangrilux connects without replacing your hardware. New integrations added on request.',
    integrations_cta: 'Explore the Marketplace',

    /* ── TEAM ROLES ───────────────────────────────────────────────── */
    team_label: 'Your team',
    team_title: 'Each person sees\nonly what they need.',
    team_sub: 'Shangrilux uses a role system so staff, suppliers and guests each have access to the right functions — without over-permission and without having to learn the whole platform.',
    team_1_role: 'Owner',
    team_1_title: 'Complete control.',
    team_1_desc: 'Dashboard with occupancy, revenue and operational logs. CSV export, property configuration, plan management. Delegate without losing visibility.',
    team_2_role: 'Staff',
    team_2_title: 'Their operations only.',
    team_2_desc: 'Confirm or reject bookings, send the digital key to guests, manage add-on services. Access limited to their property — no restricted areas.',
    team_3_role: 'Supplier',
    team_3_title: 'Dedicated portal, no account needed.',
    team_3_desc: 'Receives a private link by email. Sees service details and submits their quote. No registration, no access to the admin panel.',
    team_4_role: 'Guest',
    team_4_title: 'Autonomous access, zero friction.',
    team_4_desc: 'Receives a link by email or WhatsApp. Opens the door, reads property info, controls smart devices — from their phone, nothing to install.',

    /* ── WHY OSTIVEX ──────────────────────────────────────────────── */
    why_label: 'Differences',
    why_title: 'What Shangrilux includes\nthat generic PMS tools don\'t.',
    compare_feature: 'Feature',
    compare_other: 'PMS / Generic software',
    compare_ostivex: 'Shangrilux',
    compare_rows_it: [
      ['Digital key without any app installed',         false, true],
      ['Native smart home (18 brands)',                 false, true],
      ['Supplier portal with PDF quote',                false, true],
      ['Guest App installable via browser',             false, true],
      ['White-label without vendor branding',           false, true],
      ['Native bilingual panel Italian / English',      false, true],
      ['Multi-property with isolated databases',        false, true],
      ['Public API + HMAC-SHA256 signed webhooks',      false, true],
    ],

    /* ── HOW IT WORKS ─────────────────────────────────────────────── */
    how_label: 'Setup',
    how_title: 'Live in three phases.',
    how1_t: '01 · Configuration',
    how1_d: 'The guided wizard takes you from account creation to property setup. It takes around 15–30 minutes. You can do it independently or with our team\'s support.',
    how2_t: '02 · Customisation',
    how2_d: 'Add seasonal rates, available services and booking rules. Connect your smart home devices at this stage through the available integrations.',
    how3_t: '03 · Operational',
    how3_d: 'The booking portal, digital keys and Guest App are ready. Automations run from day one: expiries, notifications and session cleanup require no manual routine.',

    /* ── TESTIMONIALS ─────────────────────────────────────────────── */
    testimonials_label: 'Who uses it',
    testimonials_title: 'Three real cases.',
    testimonials: [
      {
        name: 'Marco Visentin',
        role: 'Owner · Villa Monterosa',
        location: 'Lake Como, CO',
        text: 'Before, I had to physically coordinate key handovers — often with delays or issues. Now guests receive a link, unlock the door from their phone and never call me. Check-in is completely autonomous.',
        stars: 5,
        metric: 'Fully autonomous check-in',
      },
      {
        name: 'Giulia Raffaelli',
        role: 'Operations Manager · Palazzo Cà Nova',
        location: 'Venice, VE',
        text: 'I manage 12 apartments. Before, we used three separate tools for bookings, quotes and communications. Now it\'s all in the same panel. Admin time has dropped significantly — I\'d estimate around 50–60%.',
        stars: 5,
        metric: '12 properties, one panel',
      },
      {
        name: 'Andrea Mancini',
        role: 'Director · Boutique Hotel Arcadia',
        location: 'Florence, FI',
        text: 'I needed a solution with no vendor branding visible to guests. The Elite plan gives us full white-label: the panel and emails are entirely ours. The Nuki integration removed physical key logistics completely.',
        stars: 5,
        metric: 'Full white-label, zero vendor visibility',
      },
    ],

    /* ── SECURITY ─────────────────────────────────────────────────── */
    security_label: 'Operational security',
    security_title: 'Every access tracked.\nEvery operation logged.',
    security_sub: 'Shangrilux is built for environments where traceability isn\'t optional. Physical access, admin operations and guest data are separated, signed and auditable.',
    security_1_t: 'Real-time access log',
    security_1_d: 'Every door open, smart home command and admin action is logged with timestamp, IP and operator identity. Exportable as CSV.',
    security_2_t: 'Separated roles and permissions',
    security_2_d: 'Three access levels: superadmin, admin, viewer. No team member sees data outside their scope. Delegation doesn\'t compromise the owner\'s visibility.',
    security_3_t: 'Digital keys with cryptographic expiry',
    security_3_d: 'Every key is HMAC-signed and valid only during the configured stay window. It cannot be reused, transferred, or extended without authorisation.',
    security_4_t: 'Per-property data isolation',
    security_4_d: 'Each property has its own database — no data crosses between tenants. Multi-tenant architecture with full isolation and deletion on request.',
    security_5_t: 'Verifiable webhook signatures',
    security_5_d: 'Events sent to external systems include a verifiable HMAC-SHA256 signature. Failed deliveries are automatically retried with status logs.',
    security_6_t: 'Operations audit trail',
    security_6_d: 'Every panel change is recorded: who confirmed a booking, who changed a rate, who revoked a key. Consultable at any time.',

    /* ── PRICING ──────────────────────────────────────────────────── */
    pricing_label: 'Pricing',
    pricing_title: 'Three plans.', pricing_title2: 'Clear pricing, no surprises.',
    pricing_sub: 'Every plan includes the full admin panel, booking portal, Guest App and support. Annual billing, one upfront payment.',
    pricing_monthly_label: '/ month', pricing_annual_label: '· billed annually',
    pricing_cta: 'Activate free demo',
    pricing_popular: 'Most popular',
    plan1_name: 'Essential',
    plan1_desc: 'One property, digital access and bookings. The starting point for removing physical keys and managing reservations without operational complexity.',
    plan2_name: 'Professional',
    plan2_desc: 'Up to 5 properties, smart home, supplier portal and advanced reports. The choice for property managers and boutique hotels needing a complete operations platform.',
    plan3_name: 'Elite',
    plan3_desc: 'Unlimited properties, white-label without Shangrilux branding, API and webhooks for PMS integration. For properties requiring full operational control and system integration.',

    /* ── FAQ ──────────────────────────────────────────────────────── */
    faq_label: 'FAQ',
    faq_title: 'Frequently asked questions.',
    q1: 'Can I remove the Shangrilux branding and use my own?',
    a1: 'Yes, with the Elite plan. White-label covers the entire interface: the admin panel, Guest App and automated emails will contain no Shangrilux references. You can customise the name, logo and colours. With Professional you can set your property name, but Shangrilux branding remains visible in the UI.',
    q2: 'How complex is the smart home integration?',
    a2: 'It depends on the device. Tuya, Home Assistant and generic webhooks are configured independently from the admin panel, typically in under 30 minutes. Nuki requires bridge pairing, guided by step-by-step documentation. KNX and BACnet normally require a certified installer for bus configuration. We provide brand-specific documentation and are available to support the setup in all cases.',
    q3: 'Can I manage multiple properties from the same login?',
    a3: 'Yes. From Professional you can add up to 5 independent properties, each with its own database, guests and integrations. With Elite properties are unlimited. Each venue is isolated: data doesn\'t mix and configurations are separate.',
    q4: 'How does the free demo work?',
    a4: 'Fill in the form with your name, property and email. Within seconds you receive login credentials to a pre-configured environment: a demo property, seasonal rates, a pending booking, an active digital key and a working Guest App. You have 24 hours to explore everything. No credit card, no cancellation needed — the environment deletes automatically.',
    q5: 'How does billing work?',
    a5: 'Plans are billed annually in one upfront payment. The monthly price shown is the annual amount divided by 12. There are no setup costs, per-booking commissions, traffic thresholds or variable charges. What you see is what you pay.',
    q6: 'What happens if I exceed the properties included in my plan?',
    a6: 'You receive a notification before reaching the limit. You can upgrade at any time — all data, configurations and history are preserved. There is no automatic block or service interruption.',
    q7: 'Is there a one-time purchase option?',
    a7: 'Yes. The Lifetime licence gives permanent access to the platform including all future updates, with no annual fee. Available on request with a personalised quote based on your number of properties. Write to us at info@shangrilux.com.',
    q8: 'Can I install it on my own server or private cloud?',
    a8: 'Yes. Shangrilux is available in self-hosted mode on any Linux server with Docker. We provide: installation documentation, environment variables, startup scripts and onboarding support. You can use your own cloud provider (AWS, Hetzner, OVH, etc.) and retain full control over data and infrastructure.',
    q9: 'What support is included?',
    a9: 'Essential includes email support with a response within 48 business hours. Professional includes priority support with a 24-hour response. Elite includes a dedicated channel (email + scheduled video call), contractually guaranteed response time and assisted onboarding sessions for the initial setup.',
    q10: 'Is guest data secure?',
    a10: 'Each property has a physically isolated database — no data crosses between tenants. Digital keys use HMAC-SHA256 cryptographic signatures and expire automatically at end of stay. All admin operations are logged in an immutable audit trail. Data is deleted at the end of the contract on written request, at no additional cost.',

    /* ── DEMO FORM ────────────────────────────────────────────────── */
    demo_label: 'Free demo',
    demo_title: '24 hours to explore Shangrilux\nwith no commitment.',
    demo_sub: 'No credit card. Get immediate credentials to a complete environment with pre-configured data and all Elite plan features active.',
    demo_badge: 'Elite plan · 24 hours · Auto-deletion',
    demo_name: 'Full name',
    demo_company: 'Property name',
    demo_email: 'Email address',
    demo_phone: 'Phone (optional)',
    demo_plan: 'Plan of interest',
    demo_submit: 'Activate free demo',
    demo_submitting: 'Creating your demo...',
    demo_success_title: 'Your demo is ready.',
    demo_success_sub: 'You have 24 hours to explore the pre-configured environment. Credentials have also been sent to your email.',
    demo_copy: 'Copy link',
    demo_copied: 'Copied!',
    demo_open_panel: 'Open admin panel',
    demo_credentials: 'Access credentials',
    demo_expires: 'Demo active for 24 hours · deletes automatically at expiry',
    demo_email_note: 'Credentials also sent to the email provided.',
    demo_microcopy: 'No credit card required · Active immediately · Auto-deleted at expiry',
    demo_items: [
      'Demo property with seasonal rates configured',
      'Add-on services (breakfast, transfer, late checkout)',
      '1 pending booking with an active digital key',
      'Working Guest App (openable from mobile)',
      'Elite plan active: all features without limits',
    ],

    /* ── LOGIN ────────────────────────────────────────────────────── */
    login_title: 'Access your panel',
    login_sub: 'Enter your property slug to open the admin panel.',
    login_slug_label: 'Property slug',
    login_slug_placeholder: 'e.g. villa-aurora',
    login_go: 'Open panel',
    login_no_account: 'Don\'t have access yet?',

    /* ── FOOTER ───────────────────────────────────────────────────── */
    footer_tagline: 'Operations platform for luxury hospitality properties.',
    footer_dev: 'Designed and developed by',
    footer_rights: 'All rights reserved.',
    footer_privacy: 'Privacy Policy',
    footer_terms: 'Terms of Service',
    footer_contact: 'Contact',
  },
};

/* ─── Brands Grid ──────────────────────────────────────────────────────── */
export const BRANDS_ALL = [
  { name: 'Nuki',          cat: 'Serrature'   },
  { name: 'Tuya',          cat: 'Smart'        },
  { name: 'Home Assistant', cat: 'Hub'          },
  { name: 'KNX',           cat: 'Impianti'     },
  { name: 'Loxone',        cat: 'Automazione'  },
  { name: 'BTicino',       cat: 'Impianti'     },
  { name: 'Somfy',         cat: 'Tapparelle'   },
  { name: 'Yale / August', cat: 'Serrature'    },
  { name: 'Schlage',       cat: 'Serrature'    },
  { name: 'Tedee',         cat: 'Serrature'    },
  { name: 'Salto KS',      cat: 'Access'       },
  { name: 'dormakaba',     cat: 'Access'       },
  { name: 'Fibaro',        cat: 'Smart'        },
  { name: 'Nice',          cat: 'Cancelli'     },
  { name: 'MyQ',           cat: 'Garage'       },
  { name: 'Webhook',       cat: 'Custom'       },
  { name: 'MQTT',          cat: 'Protocollo'   },
  { name: 'Modbus',        cat: 'Industriale'  },
];

/* ─── FAQ Keys ─────────────────────────────────────────────────────────── */
export const FAQS = ['q1', 'q2', 'q3', 'q4', 'q5', 'q6', 'q7', 'q8', 'q9', 'q10'];

/* ─── Pricing Plans ────────────────────────────────────────────────────── */
export const PLANS_DATA = [
  {
    key: 'essenziale', priceMonthly: 300, priceAnnual: 3600, popular: false,
    features_it: [
      '1 struttura',
      'Pannello admin completo',
      'Portale prenotazioni con calendario',
      'Guest App (iOS e Android, via browser)',
      'Chiavi digitali — fino a 10 al mese',
      'Log accessi base',
      'Tariffe stagionali',
      'Supporto email (risposta entro 48h)',
    ],
    features_en: [
      '1 property',
      'Full admin panel',
      'Booking portal with calendar',
      'Guest App (iOS & Android, via browser)',
      'Digital keys — up to 10 per month',
      'Basic access log',
      'Seasonal rates',
      'Email support (reply within 48h)',
    ],
    missing_it: ['Smart home', 'Portale fornitori', 'Export CSV', 'Testi personalizzabili (i18n)', 'Multi-struttura', 'White-label'],
    missing_en: ['Smart home', 'Supplier portal', 'CSV export', 'Editable texts (i18n)', 'Multi-property', 'White-label'],
  },
  {
    key: 'professional', priceMonthly: 750, priceAnnual: 9000, popular: true,
    features_it: [
      'Fino a 5 strutture indipendenti',
      'Tutto il piano Essenziale',
      'Guest App con modalità offline',
      'Chiavi digitali illimitate',
      'Smart home (5 brand, fino a 25 dispositivi)',
      'Portale fornitori con preventivi PDF',
      'Export CSV ricavi e log',
      'Calendario tariffe con heatmap',
      'Fino a 3 admin per struttura',
      'Supporto prioritario (risposta entro 24h)',
    ],
    features_en: [
      'Up to 5 independent properties',
      'Everything in Essential',
      'Guest App with offline mode',
      'Unlimited digital keys',
      'Smart home (5 brands, up to 25 devices)',
      'Supplier portal with PDF quotes',
      'Revenue and log CSV export',
      'Rate heatmap calendar',
      'Up to 3 admins per property',
      'Priority support (reply within 24h)',
    ],
    missing_it: ['Testi personalizzabili (i18n)', 'White-label', 'Smart home illimitato', 'API e Webhook'],
    missing_en: ['Editable texts (i18n)', 'White-label', 'Unlimited smart home', 'API & Webhooks'],
  },
  {
    key: 'elite', priceMonthly: 1500, priceAnnual: 18000, popular: false,
    features_it: [
      'Strutture illimitate',
      'Tutto il piano Professional',
      'Smart home illimitato (18 brand testati)',
      'Testi della piattaforma personalizzabili (IT + EN)',
      'White-label completo — nessun riferimento a Shangrilux',
      'Admin illimitati',
      'API pubblica documentata',
      'Webhook con firma HMAC-SHA256',
      'Tutti gli aggiornamenti futuri inclusi',
      'Onboarding assistito',
      'Supporto dedicato con SLA',
    ],
    features_en: [
      'Unlimited properties',
      'Everything in Professional',
      'Unlimited smart home (18 tested brands)',
      'Editable platform texts (IT + EN)',
      'Full white-label — no Shangrilux references',
      'Unlimited admins',
      'Documented public API',
      'HMAC-SHA256 signed webhooks',
      'All future updates included',
      'Assisted onboarding',
      'Dedicated support with SLA',
    ],
    missing_it: [],
    missing_en: [],
  },
];
